import React, {Component} from 'react';
import UserEditModal from "./modals/UserEditModal";
import Moment from "react-moment";
import BackEnd from "../../../backend/BackEnd";
import {successToast} from "../../../utils/toasts";
import ActionLink from "../../../controls/ActionLink";
import DataGrid from "../../../datagrid/DataGrid";
import DataColumn from "../../../datagrid/DataColumn";

class Users extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        showUserEditModal: false,
        currentUserId: 0
    };

    render() {
        return (
            <div>
                <div className="page-header">
                    <div className="row">
                        <div className="col-md-4 text-xs-center text-md-left text-nowrap">
                            <h1>
                                <span className="text-muted font-weight-light">
                                    <i className="page-header-icon ion-ios-list-outline"/> Справочники /
                                </span> Пользователи
                            </h1>
                        </div>
                        <div className="col-xs-12 width-md-auto width-lg-auto width-xl-auto pull-md-right">
                            <button type="button" className="btn btn-primary btn-block"
                                    onClick={() => this.createUser()}>Добавить
                            </button>
                        </div>
                    </div>
                </div>
                <DataGrid ref={grid => this.grid = grid}
                          dataSource={new BackEnd.UsersAdmin.GetGridResult()}
                          gridId="UserGrid"
                          pageSize={15}>
                    <DataColumn fieldName="phoneNumber" type="string"
                                caption="Телефон"
                                cell={user =>
                                    <ActionLink onClick={() => this.editUser(user)}>
                                        {user.phoneNumber}
                                    </ActionLink>
                                }/>
                    <DataColumn fieldName="email" type="string"
                                caption="Email"
                                cell={user =>
                                    !!user.email &&
                                    <ActionLink onClick={() => this.editUser(user)}>
                                        {user.email}
                                    </ActionLink>
                                }/>
                    <DataColumn fieldName="name" type="string"
                                caption="Имя"
                                cell={user => user.name}/>
                    <DataColumn fieldName="company" type="string"
                                caption="Компания"
                                cell={user => user.company.text}/>
                    <DataColumn fieldName="role" type="string"
                                caption="Роль"
                                cell={user => user.role.text}/>
                    <DataColumn fieldName="termsAcceptedAt" type="date"
                                caption="Дата и время согласия на обработку персональных данных"
                                cell={user =>
                                    !!user.termsAcceptedAt &&
                                    <Moment format="DD.MM.YYYY HH:mm">{user.termsAcceptedAt}</Moment>
                                }/>
                    <DataColumn fieldName="lastActivityTimestamp" type="date"
                                caption="Дата и время последней активности"
                                cell={user =>
                                    !!user.lastActivityTimestamp &&
                                    <Moment format="DD.MM.YYYY HH:mm">{user.lastActivityTimestamp}</Moment>
                                }/>
                    <DataColumn fieldName="isEmailSubscribed" type="string"
                                caption="Email уведомления"
                                cell={user =>
                                    <label className="custom-control custom-checkbox checkbox-inline">
                                        <input type="checkbox" className="custom-control-input"
                                               checked={user.isEmailSubscribedFlag}
                                               onChange={event => this.updateReceiveEmailNotification(user, event.target.checked)}/>
                                        <span className="custom-control-indicator"/>
                                        &nbsp;
                                    </label>
                                }/>
                    <DataColumn fieldName="isActive" type="string"
                                caption="Активен"
                                cell={user =>
                                    <label className="custom-control custom-checkbox checkbox-inline">
                                        <input type="checkbox" className="custom-control-input"
                                               checked={user.isActiveFlag}
                                               onChange={event => this.updateActive(user, event.target.checked)}/>
                                        <span className="custom-control-indicator"/>
                                        &nbsp;
                                    </label>
                                }/>
                </DataGrid>
                <UserEditModal userId={this.state.currentUserId}
                               show={this.state.showUserEditModal}
                               onSave={() => this.grid.fetchGridData()}
                               onHide={() => this.setState({showUserEditModal: false, currentUserId: 0})}/>
            </div>
        );
    }

    createUser() {
        this.setState({
            showUserEditModal: true
        });
    }

    editUser({userId}) {
        this.setState({
            showUserEditModal: true,
            currentUserId: userId
        });
    }

    async updateReceiveEmailNotification({userId}, flag) {
        let changeEmailNotificationState = new BackEnd.UsersAdmin.ChangeEmailNotificationState();
        let result = await changeEmailNotificationState.call({
            userId,
            emailNotification: flag
        });

        if (result.success) {
            successToast(flag
                ? 'Email уведомления включены'
                : 'Email уведомления выключены');

            await this.grid.fetchGridData();
        }
    }

    async updateActive({userId}, flag) {
        let changeUserActivity = new BackEnd.UsersAdmin.ChangeUserActivity();
        let result = await changeUserActivity.call({
            userId,
            activity: flag
        });

        if (result.success) {
            successToast(flag
                ? 'Пользователь активирован'
                : 'Пользователь деактивирован');

            await this.grid.fetchGridData();
        }
    }
}

export default Users;


// WEBPACK FOOTER //
// ./src/pages/Catalogs/Users/Users.js